<template>
  <div v-if="isNotificationRender" id="covid-safety-regulation" class="regulationContainer">
    <h3 class="regulationTitle">{{strings.safeMeetingPolicy}}</h3>
    <a v-if="pdfUrl" :href="pdfUrl" target="_blank"><i class="fa fa-file-pdf-o pdfIcon" aria-hidden="true" ></i></a>
    <p class="regulationContent" v-html="message"></p>
    <p v-if="pdfUrl">{{strings.notificationPdfMessage}}</p>
  </div>
</template>

<script>
export default {
  computed: {
    message() {
      if (this.availableCapacityPercentage) {
        let messageObj = this.availableCapacityPercentage.message
        return messageObj[this.selectedLang] ? messageObj[this.selectedLang] : messageObj['en']
      }
      return this.strings.notificationDefaultMessage
    },
    pdfUrl() {
      if (this.availableCapacityPercentage) {
        return this.availableCapacityPercentage.pdfUrl
      }
      return ''
    },
    selectedLang() {
      return this.$store.state.selectedLang
    },
    availableCapacityPercentage() {
      return this.$store.state.venueInfo.available_capacity_percentage ? this.$store.state.venueInfo.available_capacity_percentage : {}
    },
    strings() {
      return this.$store.state.strings
    },
    isNotificationRender() {
      if (this.availableCapacityPercentage)
        return this.availableCapacityPercentage.toggle
    }
  }
}
</script>

<style scoped>
  .regulationContainer {
    margin-bottom: 30px;
    font-family: inherit;
    background-color: whitesmoke;
    padding: 30px;
    color: black;
  }
  .regulationTitle {
    display: inline;
    padding-top: 20px;
    padding-bottom: 30em;
    line-height: 1.25;
  }
  .regulationContent {
    margin-top: 30px;
  }
  .pdfIcon {
    font-size: 24px;
    margin-left: 10px;
    font-family: FontAwesome !important;
    color: black;
  }
  .pdfIcon:hover {
    cursor: pointer;
  }
</style> 